module.exports = __webpack_public_path__ + "media/images/icon-warning-f89bd429f9752e0397e8aa3f159b784a.svg";